import {getNestedTranslation, TranslationObject} from '@colonist/i18n'
import {NonFunctionProperties, SharedStrings} from '@colonist/types'
import {BaseError, RedirectUrl} from './BaseError'
import {ErrorTypes, HTTPStatus} from './ErrorEnums'
import {LogSeverity} from './LogSeverity'

export interface ErrorAPIInterface {
    error: BaseError
}

export class ErrorDefault extends BaseError {
    readonly type = ErrorTypes.DefaultError

    constructor(title: TranslationObject, message: TranslationObject, httpStatusCode: HTTPStatus, logSeverity: LogSeverity = LogSeverity.JL2, redirectUrl?: RedirectUrl) {
        super(title, message, httpStatusCode, logSeverity, redirectUrl)
    }

    static deserialize(data: NonFunctionProperties<BaseError>): BaseError {
        // eslint-disable-next-line
        // @ts-ignore
        return new ErrorDefault(data.title, data.description, data.httpStatusCode, data.logSeverity, data.redirectUrl)
    }
}

export abstract class ErrorAuth extends BaseError {
    readonly type = ErrorTypes.AuthError

    constructor(title: TranslationObject, message: TranslationObject, httpStatusCode: HTTPStatus, logSeverity: LogSeverity = LogSeverity.JL4, redirectUrl?: RedirectUrl) {
        super(title, message, httpStatusCode, logSeverity, redirectUrl)
    }

    getDisplayMessage(): TranslationObject {
        const displayMessage: TranslationObject = {key: 'strings:popups.errors.authError.displayMessage'}
        const errorMessage = this.description.key
        const standardErrorMessage: TranslationObject = {
            key: 'strings:popups.errors.authError.standardErrorMessage',
            options: {
                email: SharedStrings.SUPPORT_EMAIL,
            },
        }
        return getNestedTranslation(displayMessage, {
            errorMessage: {key: errorMessage},
            standardErrorMessage: standardErrorMessage,
        })
    }

    static deserialize(data: NonFunctionProperties<ErrorAuth>): BaseError {
        // eslint-disable-next-line
        // @ts-ignore
        return new ErrorAuth(data.title, data.description, data.httpStatusCode)
    }
}

export abstract class ErrorMustLogin extends BaseError {
    readonly type = ErrorTypes.MustLogin

    constructor(title: TranslationObject, message: TranslationObject, httpStatusCode: HTTPStatus, logSeverity: LogSeverity = LogSeverity.JL2) {
        super(title, message, httpStatusCode, logSeverity)
    }

    static deserialize(data: NonFunctionProperties<ErrorMustLogin>): BaseError {
        // eslint-disable-next-line
        // @ts-ignore
        return new ErrorMustLogin(data.title, data.description, data.httpStatusCode)
    }
}

export abstract class ErrorMustBeMember extends BaseError {
    readonly type = ErrorTypes.MustBeMember

    constructor(title: TranslationObject, message: TranslationObject, httpStatusCode: HTTPStatus, logSeverity: LogSeverity = LogSeverity.JL2) {
        super(title, message, httpStatusCode, logSeverity)
    }

    static deserialize(data: NonFunctionProperties<ErrorMustBeMember>): BaseError {
        // eslint-disable-next-line
        // @ts-ignore
        return new ErrorMustBeMember(data.title, data.description, data.httpStatusCode, data.logSeverity)
    }
}

export abstract class ErrorBlocking extends BaseError {
    readonly type = ErrorTypes.Blocking

    constructor(title: TranslationObject, message: TranslationObject, httpStatusCode: HTTPStatus, logSeverity: LogSeverity = LogSeverity.JL2) {
        super(title, message, httpStatusCode, logSeverity)
    }

    static deserialize(data: NonFunctionProperties<ErrorBlocking>): BaseError {
        // eslint-disable-next-line
        // @ts-ignore
        return new ErrorBlocking(data.title, data.description, data.httpStatusCode, data.logSeverity)
    }
}
